
if (process.env.NODE_ENV === 'test') {
    module.exports = {
        siteRoot: 'http://localhost:3200',
        educationDomain: process.env.REACT_APP_EDUCATION_DOMAIN,
        employerDomain: process.env.REACT_APP_EMPLOYER_DOMAIN,
    };
} else if (process.env.NODE_ENV === 'production') {
    module.exports = {
        siteRoot: '',
        educationDomain: process.env.REACT_APP_EDUCATION_DOMAIN,
        employerDomain: process.env.REACT_APP_EMPLOYER_DOMAIN,
    };
} else {
    module.exports = {
        siteRoot: '',
        educationDomain: process.env.REACT_APP_EDUCATION_DOMAIN,
        employerDomain: process.env.REACT_APP_EMPLOYER_DOMAIN,
    };
}



//////////////////
// WEBPACK FOOTER
// ./src/config/index.js
// module id = 407
// module chunks = 58